var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_989_9359)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 35,
    r: 35,
    fill: "#51CDA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 35.5C51 28.5962 45.4038 23 38.5 23C31.5963 23 26 28.5962 26 35.5C25.9972 37.5251 26.4885 39.5202 27.4313 41.3125L26.0363 46.6737C25.9898 46.853 25.9909 47.0412 26.0396 47.2199C26.0883 47.3985 26.1828 47.5613 26.3138 47.6922C26.4448 47.8231 26.6077 47.9174 26.7864 47.9659C26.9651 48.0144 27.1533 48.0154 27.3325 47.9687L32.695 46.5725C34.4854 47.5127 36.4778 48.0027 38.5 48C45.4038 48 51 42.4037 51 35.5Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2497 18.2959L54.2492 18.2955L53.725 17.7713C53.725 17.7713 53.7249 17.7712 53.7249 17.7712C53.7248 17.7711 53.7247 17.771 53.7246 17.7709C52.5011 16.5464 50.575 16.8877 49.4447 18.0168L49.4443 18.0172L38.6551 28.8073L38.5003 28.9621L38.4243 29.1676L37.119 32.6982C36.9984 33.0156 36.9687 33.3603 37.0334 33.6938L37.0333 33.6938L37.036 33.7072C37.2686 34.8249 38.4034 35.2435 39.3146 34.9095C39.3146 34.9094 39.3147 34.9094 39.3148 34.9094C39.3153 34.9092 39.3157 34.909 39.3161 34.9089L42.8199 33.6272L43.0273 33.5513L43.1835 33.3951L54.0025 22.5761C54.0027 22.576 54.0028 22.5759 54.0029 22.5757C55.1352 21.4443 55.471 19.5188 54.2497 18.2959Z",
    fill: "white",
    stroke: "#51CDA0",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_989_9359",
    x: 0,
    y: 0,
    width: 78,
    height: 78,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_989_9359"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_989_9359",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewChat);
export default __webpack_public_path__ + "static/media/newChat.d7ca3a7adbebde20829b1132490ec6a4.svg";
export { ForwardRef as ReactComponent };